import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  effect,
  inject,
  } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { environment } from '../../../environments/environment';
import {
  HealthCheckApiService,
  StaffApiService,
  SupervisorApiService,
} from '../../core/api/services';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GeneralAttachmentModel,
  MaintenanceCriteriaModel,
  PatientBehaviorModel,
  PatientBehaviorType,
  PatientModel,
  PatientPlaylistModel,
  PatientProgramModel,
  PatientReminderModel,
  PatientSessionModel,
  PatientTargetDataModel,
  PatientTargetModel,
  PatientTargetStatus,
  PromptCodeModel,
  PromptScheduleModel,
  TargetNoteMessageModel,
  TargetType,
} from '../../core/api/models';
import {
  PatientPlaylistWithItemsModel,
  PatientProgramWithCountersModel,
  PatientReminderWithLastTimeModel,
  PatientTargetForChainModel,
} from '../../shared/models/models';
import { getPatientTargetStatusColor } from '../../shared/utils/utils';

import { catchError, forkJoin, Observable, of } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PatientSessionService } from './patient-session.service';
import { ProgressNoteComponent } from './progress-note/progress-note.component';
import { AlertService } from '../../shared/services/alert.service';
import { OfflineDataService, PatientOfflineData } from '../../core/services/offline-data.service';
import { SessionCollaborationSyncService } from '../../core/services/session-collaboration-sync.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SendLogsService } from '../../core/services/send-logs.service';
import { AcademyModeService } from '../../core/services/academy-mode.service';
import { SparkLightLoadService } from '../../core/services/spark-light-load.service';
@Component({
  selector: 'staff-home',
  templateUrl: './staff-home.component.html',
  styleUrls: ['./staff-home.component.css'],
  standalone: false,
})
export class StaffHomeComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() groupMode: boolean = false;
  @Input() groupPatientID?: number;
  @Input() groupSessionID?: number;
  @Output() groupSessionFinished = new EventEmitter<void>();

  loading: boolean = true;
  private isLoadingData: boolean = false;
  private dataLoadGeneration = 0;
  isTimerRunning: boolean = false;
  timerValue: number = 0;
  patientSession: PatientSessionModel | null = null;
  programs: PatientProgramWithCountersModel[] = [];
  playlists: PatientPlaylistWithItemsModel[] = [];
  targets: PatientTargetModel[] = [];
  genericPromptCodes: PromptCodeModel[] = [];
  subTargetsDictionary: { [parentTargetID: number]: PatientTargetForChainModel[] } = {};
  favoriteTargets: PatientTargetModel[] = [];
  specialFavoriteTargets: PatientTargetModel[] = [];
  patientID?: number;
  sessionID?: number;
  showingItems: {
    Title: string;
    Name: string;
    Targets: PatientTargetModel[];
    ProgramID?: number;
    TargetID?: number;
    ProgramNotes?: string;
    ProgramNotesLastModifiedByUserFullName?: string;
    ProgramNotesLastModifiedDate?: string;
    TargetNotes?: string;
    TargetNotesLastModifiedByUserFullName?: string;
    TargetNotesLastModifiedDate?: string;
    ShowMasteredTargets?: boolean;
    ShowMaintenanceTargets?: boolean;
  }[] = [];
  groupedShowingItems: {
    Title: string;
    items: {
      Title: string;
      Name: string;
      Targets: PatientTargetModel[];
      ProgramID?: number;
      TargetID?: number;
      ProgramNotes?: string;
      ProgramNotesLastModifiedByUserFullName?: string;
      ProgramNotesLastModifiedDate?: string;
      TargetNotes?: string;
      TargetNotesLastModifiedByUserFullName?: string;
      TargetNotesLastModifiedDate?: string;
      ShowMaintenanceTargets?: boolean;
      ShowMasteredTargets?: boolean;
    }[];
  }[] = [];
  patient: PatientModel | null = null;
  reminders: PatientReminderWithLastTimeModel[] = [];
  showingReminders: PatientReminderWithLastTimeModel[] = [];
  behaviors: PatientBehaviorModel[] = [];

  isProgramNotesShowing: boolean = false;
  isTargetNotesShowing: boolean = false;
  isEditingProgramNotes: boolean = false;
  isEditingTargetNotes: boolean = false;

  selectedItemsIndexes: number[] = [];

  selectedProgramIndex: number = -1;
  selectedPlaylistIndex: number = -1;
  selectedTargetIndex: number = -1;

  showEndSession: boolean = false;

  showingProgressNote: boolean = false;

  promptSchedules: PromptScheduleModel[] = [];
  showFilterDialog: boolean = false;
  filterText: string = '';
  filteredPrograms: PatientProgramWithCountersModel[] = [];
  filteredPlaylists: PatientPlaylistWithItemsModel[] = [];
  filteredTargets: PatientTargetModel[] = [];

  justFinishedSession: boolean = false;

  isPreview: boolean = false;

  startingPreview: boolean = false;

  @ViewChild('progressNoteComponent') progressNoteComponent!: ProgressNoteComponent;

  isOfflineMode: boolean = false;

  programToShowDetails: PatientProgramModel | null = null;
  detailsOpened: boolean = false;
  playlistToShowDetails: PatientPlaylistModel | null = null;
  playlistDetailsOpened: boolean = false;

  PatientTargetStatus = PatientTargetStatus;

  showMasteredTargetsOnProgram: { [programID: number]: boolean } = {};

  showMaintenanceTargetsOnProgram: { [programID: number]: boolean } = {};

  patientInstructionsOpened: boolean = false;
  patientInstructions: string = '';
  instructionFiles: GeneralAttachmentModel[] = [];
  doShowAttachmentView: boolean = false;
  selectedAttachment: GeneralAttachmentModel | null = null;

  // BIP modal state
  showBipDialog: boolean = false;
  bipView: 'QuickReference' | 'Behaviors' | 'CrisisCycle' | 'EmergencyProcedures' | 'AdditionalInfo' | null = null;
  bipScrollFragment: string | null = null;

  targetsData: PatientTargetDataModel[] = [];

  private finishedTrialsByProgram: Record<number, number> = {};
  private maintenanceTakenByTargetId: Record<number, boolean> = {};

  displayingItems: boolean = false;

  isStartingSession: boolean = false;

  private readonly destroyRef = inject(DestroyRef);
  protected readonly lightLoad = inject(SparkLightLoadService);
  private timerTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private loadingWatchdogTimerId: ReturnType<typeof setTimeout> | null = null;
  private isDestroyed = false;
  private viewInitialized = false;


  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private supervisorApiService: SupervisorApiService,
    private router: Router,
    private staffApiService: StaffApiService,
    protected patientSessionService: PatientSessionService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private offlineDataService: OfflineDataService,
    protected sessionCollaborationSyncService: SessionCollaborationSyncService,
    private sendLogsService: SendLogsService,
    protected sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private academyModeService: AcademyModeService
  ) {


    effect(() => {
      this.patientSessionService.dataChanged();
      const wasStarted = this.isStarted();
      this.patientSession = this.patientSessionService.getPatientSession();
      const isStarted = this.isStarted();

      if (this.isStarted() && !this.isTimerRunning) {
        this.updateTimer();
      }

      if (!this.isStarted()) {
        this.isTimerRunning = false;
        this.timerValue = 0;
      }
      if (this.isStarted()) {
        this.isStartingSession = false;
      }

      this.targetsData = this.patientSession?.TargetData ?? [];
      this.rebuildDerivedMetrics();

      if (!this.groupMode && this.sessionID && this.patientID && this.patientSession && this.patientSession.FinishedDate && !this.justFinishedSession) {
        this.alertService.error("Session already finished.");
        this.navigateWithAcademyMode(['/staff/' + this.patientID + '/sessions']);
      }

      if (this.sessionID && this.patientID && this.patientSession && this.patientSession.DeletedDate) {
        this.alertService.error("Session Deleted.");
        this.navigateWithAcademyMode(['/staff/' + this.patientID + '/sessions']);
      }

    });

    effect(() => {
      //if the patient session ID changes, update it here and also change the URL
      const patientSession = this.patientSessionService.getPatientSession();
      console.log('patientSession', patientSession);
      if (!patientSession || this.isPreview || this.groupMode || !this.patientID || !patientSession.ID) {
        return;
      }

      const patientID = patientSession.PatientID ?? this.patientID;
      if (patientSession.ID !== this.sessionID && patientID) {
        this.patientID = patientID;
        this.sessionID = patientSession.ID;
        window.history.replaceState(
          {},
          '',
          this.academyModeService.appendModeToPath(
            `/staff/home/${patientID}/${this.sessionID}`
          )
        );
      }
      const currentSession = this.patientSessionService.getPatientSession();
      //if the patient session ID changes, update it here and also change the URL
      console.log('patientSession', currentSession);
      if (!currentSession || this.isPreview) {
        return;
      }

      const nextSessionID = currentSession.ID ?? null;
      // Never route normal staff session URLs to preview placeholder sessions.
      if (!nextSessionID || nextSessionID <= 0 || nextSessionID === this.sessionID) {
        return;
      }

      const nextPatientID =
        this.patientID ??
        (currentSession.PatientID && currentSession.PatientID > 0
          ? currentSession.PatientID
          : null);
      if (!nextPatientID) {
        return;
      }

      this.patientID = nextPatientID;
      this.sessionID = nextSessionID;
      window.history.replaceState(
        {},
        '',
        this.academyModeService.appendModeToPath(
          `/staff/home/${nextPatientID}/${nextSessionID}`
        )
      );
    });
  }

  ngOnInit() {
    // Check if we're in offline mode
    this.isOfflineMode = this.offlineDataService.isInOfflineMode();
  }

  ngAfterViewInit() {
    this.viewInitialized = true;
    if (this.groupMode) {
      this.loadGroupContext();
      return;
    }

    this.activatedRoute.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.addStaffTrace('staff-home-route-params', {
          rawPatientID: params['patientID'],
          rawSessionID: params['sessionID'],
          url: this.router.url,
        });
        const routePatientID = Number(params['patientID']);
        this.patientID =
          Number.isFinite(routePatientID) && routePatientID > 0
            ? routePatientID
            : undefined;
        this.isPreview = this.router.url.split('/')[2] === 'preview';
        if (!this.isPreview) {
          const routeSessionID = Number(params['sessionID']);
          this.sessionID =
            Number.isFinite(routeSessionID) && routeSessionID > 0
              ? routeSessionID
              : undefined;
          if (!this.patientID || !this.sessionID) {
            this.sendLogsService.addError(
              'Staff home invalid route parameters',
              JSON.stringify({
                patientID: this.patientID ?? null,
                sessionID: this.sessionID ?? null,
                url: this.router.url,
              })
            );
            this.alertService.error('Invalid session or patient');
            this.router.navigate(['/select-patient']);
            this.loading = false;
            this.isLoadingData = false;
            return;
          }
          this.patientSessionService.initializePatientSession(
            this.patientID,
            this.sessionID
          );
        } else {
          if (!this.patientID) {
            this.router.navigate(['/select-patient']);
          }
          this.startingPreview = true;
        }

        this.getData();

        this.cdr.detectChanges();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.groupMode &&
      this.viewInitialized &&
      (changes['groupPatientID'] || changes['groupSessionID'])
    ) {
      this.loadGroupContext();
    }
  }

  private loadGroupContext(): void {
    const patientID = Number(this.groupPatientID);
    const sessionID = Number(this.groupSessionID);
    if (
      !Number.isFinite(patientID) ||
      patientID <= 0 ||
      !Number.isFinite(sessionID) ||
      sessionID === 0
    ) {
      this.loading = false;
      return;
    }

    this.patientID = patientID;
    this.sessionID = sessionID;
    this.isPreview = false;
    this.justFinishedSession = false;
    this.isLoadingData = false;
    this.sessionCollaborationSyncService.stop();
    this.patientSessionService.activateSessionContext(
      patientID,
      sessionID,
      true
    );
    this.getData();
    this.cdr.detectChanges();
  }


  initializeDisplayItems(offlineData: PatientOfflineData | null): void {
    if (!offlineData) {
      return;
    }
    const expectedPatientID = Number(this.patientID);
    const offlinePatientID = Number(offlineData.patient?.ID);
    if (
      !Number.isFinite(expectedPatientID) ||
      !Number.isFinite(offlinePatientID) ||
      expectedPatientID !== offlinePatientID
    ) {
      this.addStaffTrace('staff-home-rejected-cross-patient-data', {
        expectedPatientID,
        offlinePatientID,
      });
      return;
    }

    // Optional: Monitor memory usage during initialization
    if ((performance as any).memory) {
      console.log('Memory before initialization:', {
        used: Math.round((performance as any).memory.usedJSHeapSize / 1024 / 1024) + 'MB',
        total: Math.round((performance as any).memory.totalJSHeapSize / 1024 / 1024) + 'MB'
      });
    }

    this.displayingItems = true;
    // Set the patient
    this.patient = offlineData.patient;

    //get the showMasteredTargetsOnProgram from local storage
    const masteredTargetsStorageKey = this.patientStorageKey('showMasteredTargetsOnProgram');
    if (localStorage.getItem(masteredTargetsStorageKey)) {
      this.showMasteredTargetsOnProgram = JSON.parse(localStorage.getItem(masteredTargetsStorageKey)!);
    }    //get the showMasteredTargetsOnProgram from local storage
    const maintenanceTargetsStorageKey = this.patientStorageKey('showMaintenanceTargetsOnProgram');
    if (localStorage.getItem(maintenanceTargetsStorageKey)) {
      this.showMaintenanceTargetsOnProgram = JSON.parse(localStorage.getItem(maintenanceTargetsStorageKey)!);
    }

    // Keep preview isolated from real sessions using an in-memory preview session.
    this.patientSessionService.initializePatientSession(
      Number(this.patientID),
      this.isPreview ? -1 : this.sessionID ? Number(this.sessionID) : undefined
    );

    this.loading = true;
    // Use the updated data from PatientSessionService - avoid storing duplicate references
    this.behaviors = this.patientSessionService.getPatientBehaviors();
    this.targets = this.patientSessionService.getPatientTargets();
    this.programs = this.patientSessionService.getPrograms();
    this.playlists = this.patientSessionService.getPlaylists();
    this.promptSchedules = this.patientSessionService.getPromptSchedules();
    this.genericPromptCodes = this.patientSessionService.getGenericPromptCodes();

    this.targetsData = this.patientSessionService.getPatientSession()?.TargetData ?? [];
    this.patientInstructions = this.patientSessionService.getPatientInstructions();

    if(!this.isOfflineMode && !this.lightLoad.isEnabled()){
      const requestedPatientID = expectedPatientID;
      this.supervisorApiService.GetPatientInstructionAttachments({
        patientID: requestedPatientID
      })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
        next: (results) => {
          if (Number(this.patientID) !== requestedPatientID) {
            return;
          }
          this.instructionFiles = results;
        },
        error: (error) => {
          console.error('Error loading patient instruction attachments', error);
          this.alertService.error('Failed to load patient instruction attachments');
          this.loading = false;
        }
      });
    }

    // Build sub-targets dictionary efficiently
    this.buildSubTargetsDictionary();
    
    // Process programs with counters efficiently
    this.processPrograms();
    
    // Use reference to programs instead of copying
    this.filteredPrograms = this.programs;

    // Process playlists efficiently
    this.processPlaylists();
    
    // Use reference to playlists instead of copying
    this.filteredPlaylists = this.playlists;

    // Set favorite targets - filter once and reuse
    this.setFavoriteTargets();
    
    // Filter targets efficiently
    this.setFilteredTargets();

    // Select first available item
    this.selectFirstAvailableItem();

    // Process reminders
    this.processReminders();

    // Keep expensive template-bound counters as cached lookups.
    this.rebuildDerivedMetrics();

    if (this.startingPreview) {
      this.startSession();
      this.startingPreview = false;
    }

    this.displayingItems = false;
    this.loading = false;
    this.clearLoadingWatchdog();
    this.addStaffTrace('staff-home-display-initialized', {
      patientID: this.patientID ?? null,
      sessionID: this.sessionID ?? null,
      isPreview: this.isPreview,
      programs: this.programs.length,
      playlists: this.playlists.length,
      targets: this.targets.length,
      behaviors: this.behaviors.length,
    });

    // Optional: Monitor memory usage after initialization
    if ((performance as any).memory) {
      console.log('Memory after initialization:', {
        used: Math.round((performance as any).memory.usedJSHeapSize / 1024 / 1024) + 'MB',
        total: Math.round((performance as any).memory.totalJSHeapSize / 1024 / 1024) + 'MB'
      });
    }
  }

  private buildSubTargetsDictionary(): void {
    // Clear existing dictionary to free memory
    this.subTargetsDictionary = {};
    
    for (const target of this.targets) {
      if (target.SubTargets?.length) {
        this.subTargetsDictionary[target.ID ?? 0] = target.SubTargets
          .map(subTarget => {
            const foundTarget = this.targets.find(t => t.ID === subTarget.ID);
            return foundTarget ? { ...foundTarget, ForceOpen: subTarget.ForceOpen } : null;
          })
          .filter(t => t !== null) as PatientTargetForChainModel[];
      }
    }
  }

  private processPrograms(): void {
    // Create target lookup map once - more memory efficient than repeated array.find()
    const targetMap = new Map<number, PatientTargetModel>();
    for (const target of this.targets) {
      if (target.ID) {
        targetMap.set(target.ID, target);
      }
    }

    for (const program of this.programs) {
      // Process targets efficiently without creating new arrays
      if (program.Targets) {
        // Filter and map in place to reduce memory allocations
        program.Targets = program.Targets
          .map(t => t.ID ? targetMap.get(t.ID) : undefined)
          .filter((target): target is PatientTargetModel => !!target);
      }
      
      // Build counters efficiently using Map for O(1) lookups
      const counters = new Map<PatientTargetStatus, { targetStatus: PatientTargetStatus; count: number; color: string }>();
      
      for (const target of program.Targets ?? []) {
        if (target.TargetStatus !== undefined) {
          const existing = counters.get(target.TargetStatus);
          if (existing) {
            existing.count++;
          } else {
            counters.set(target.TargetStatus, {
              targetStatus: target.TargetStatus,
              count: 1,
              color: getPatientTargetStatusColor(target.TargetStatus),
            });
          }
        }
      }
      
      program.Counters = Array.from(counters.values());
    }
  }

  private processPlaylists(): void {
    // Build lookup maps once for all playlists - more memory efficient
    const programMap = new Map<number, PatientProgramModel>();
    const targetMap = new Map<number, PatientTargetModel>();
    
    for (const program of this.programs) {
      if (program.ID) {
        programMap.set(program.ID, program);
      }
    }
    
    for (const target of this.targets) {
      if (target.ID) {
        targetMap.set(target.ID, target);
      }
    }

    for (const playlist of this.playlists) {
      // Clear and rebuild filled items efficiently
      if (!playlist.FilledItems) {
        playlist.FilledItems = [];
      } else {
        playlist.FilledItems.length = 0; // Clear array efficiently
      }
      
      // Sort items in place to avoid creating new array
      playlist.Items?.sort((a, b) => (a.OrderNr ?? 0) - (b.OrderNr ?? 0));
      
      // Process items efficiently
      for (const item of playlist.Items ?? []) {
        if (item.PatientProgramID) {
          const program = programMap.get(item.PatientProgramID);
          if (program) playlist.FilledItems.push(program);
        } else if (item.PatientTargetID) {
          const target = targetMap.get(item.PatientTargetID);
          if (target) playlist.FilledItems.push(target);
        }
      }
    }
  }

  private setFavoriteTargets(): void {
    this.favoriteTargets = this.targets.filter(t => t.IsFavorite);
    this.specialFavoriteTargets = this.targets.filter(t => t.IsSpecialFavorite);
  }

  private setFilteredTargets(): void {
    // Use Set for O(1) lookups instead of array.some() which is O(n)
    const programTargetIds = new Set<number>();
    const subTargetIds = new Set<number>();
    
    // Build lookup sets efficiently
    for (const program of this.programs) {
      for (const target of program.Targets ?? []) {
        if (target.ID) programTargetIds.add(target.ID);
      }
    }
    
    for (const target of this.targets) {
      for (const subTarget of target.SubTargets ?? []) {
        if (subTarget.ID) subTargetIds.add(subTarget.ID);
      }
    }

    // Filter efficiently using Set lookups
    this.filteredTargets = this.targets.filter(target => {
      const targetId = target.ID ?? 0;
      return !target.IsTargetSubtarget &&
             target.TargetStatus !== PatientTargetStatus.Mastered &&
             target.TargetStatus !== PatientTargetStatus.Fluent &&
             !programTargetIds.has(targetId) &&
             !subTargetIds.has(targetId);
    });
  }

  private selectFirstAvailableItem(): void {
    if (this.playlists.length > 0) {
      this.selectPlaylist(this.playlists[0]);
    } else if (this.programs.length > 0) {
      this.selectProgram(this.programs[0]);
    } else if (this.targets.length > 0) {
      this.selectTarget(this.targets[0]);
    }
  }

  private processReminders(): void {
    const reminders = this.patientSessionService.getReminders();
    let remindersFromLocalStorage: PatientReminderWithLastTimeModel[] = [];
    
    const storedReminders = localStorage.getItem(this.patientStorageKey('reminders'));
    if (storedReminders) {
      try {
        remindersFromLocalStorage = JSON.parse(storedReminders) as PatientReminderWithLastTimeModel[];
        console.log('Getting reminders from local storage');
      } catch (error) {
        console.error('Error parsing stored reminders:', error);
      }
    }

    // Build lookup map for efficient processing
    const storedReminderMap = new Map(remindersFromLocalStorage.map(r => [r.ID, r.lastTimeClosed]));

    // Process reminders efficiently
    this.reminders = reminders.map(reminder => {
      const reminderWithTime = reminder as PatientReminderWithLastTimeModel;
      const lastTimeClosed = storedReminderMap.get(reminder.ID);
      if (lastTimeClosed !== undefined) {
        reminderWithTime.lastTimeClosed = lastTimeClosed;
      }
      return reminderWithTime;
    });
    this.checkReminders();
  }

  private rebuildDerivedMetrics(): void {
    if (!this.programs.length && !this.targets.length) {
      this.finishedTrialsByProgram = {};
      this.maintenanceTakenByTargetId = {};
      return;
    }

    const targetMap = new Map<number, PatientTargetModel>();
    for (const target of this.targets) {
      if (target.ID != null) {
        targetMap.set(target.ID, target);
      }
    }

    const targetDataCountByTargetId = new Map<number, number>();
    for (const targetData of this.targetsData) {
      if (targetData.PatientTargetID && !targetData.DeletedDate) {
        targetDataCountByTargetId.set(
          targetData.PatientTargetID,
          (targetDataCountByTargetId.get(targetData.PatientTargetID) ?? 0) + 1
        );
      }
    }

    this.rebuildFinishedTrialsByProgram(targetDataCountByTargetId, targetMap);
    this.rebuildMaintenanceTakenByTargetId(targetDataCountByTargetId, targetMap);
  }

  private rebuildFinishedTrialsByProgram(
    targetDataCountByTargetId: Map<number, number>,
    targetMap: Map<number, PatientTargetModel>
  ): void {
    const nextFinishedTrialsByProgram: Record<number, number> = {};

    for (const program of this.programs) {
      if (program.ID == null) {
        continue;
      }

      let finishedTrials = 0;
      for (const target of program.Targets ?? []) {
        if (this.isTargetFinishedForTrials(target, targetDataCountByTargetId, targetMap)) {
          finishedTrials++;
        }
      }

      nextFinishedTrialsByProgram[program.ID] = finishedTrials;
    }

    this.finishedTrialsByProgram = nextFinishedTrialsByProgram;
  }

  private rebuildMaintenanceTakenByTargetId(
    targetDataCountByTargetId: Map<number, number>,
    targetMap: Map<number, PatientTargetModel>
  ): void {
    const nextMaintenanceTakenByTargetId: Record<number, boolean> = {};

    for (const target of this.targets) {
      if (target.ID == null) {
        continue;
      }

      nextMaintenanceTakenByTargetId[target.ID] = this.isTargetMaintenanceTaken(
        target,
        targetDataCountByTargetId,
        targetMap
      );
    }

    this.maintenanceTakenByTargetId = nextMaintenanceTakenByTargetId;
  }

  private isTargetFinishedForTrials(
    target: PatientTargetModel,
    targetDataCountByTargetId: Map<number, number>,
    targetMap: Map<number, PatientTargetModel>
  ): boolean {
    if (target.SubTargets?.length) {
      const subTargets = target.SubTargets
        .map(subTarget => subTarget.ID != null ? targetMap.get(subTarget.ID) : undefined)
        .filter((subTarget): subTarget is PatientTargetModel => !!subTarget);

      if (!subTargets.length) {
        return false;
      }

      return subTargets.every(subTarget => {
        const actualTrials = targetDataCountByTargetId.get(subTarget.ID ?? 0) ?? 0;
        const desiredTrials = subTarget.DesiredTrials ?? 0;
        return actualTrials >= desiredTrials;
      });
    }

    const actualTrials = targetDataCountByTargetId.get(target.ID ?? 0) ?? 0;
    const desiredTrials = target.DesiredTrials ?? 0;
    return actualTrials >= desiredTrials;
  }

  private isTargetMaintenanceTaken(
    target: PatientTargetModel,
    targetDataCountByTargetId: Map<number, number>,
    targetMap: Map<number, PatientTargetModel>
  ): boolean {
    if (
      (target.TargetType === TargetType.TaskAnalysis ||
        target.TargetType === TargetType.GroupedFrequency ||
        target.TargetType === TargetType.ConditionalDiscrimination) &&
      target.SubTargets?.length
    ) {
      const subTargets = target.SubTargets
        .map(subTarget => subTarget.ID != null ? targetMap.get(subTarget.ID) : undefined)
        .filter((subTarget): subTarget is PatientTargetModel => !!subTarget);

      if (!subTargets.length) {
        return false;
      }

      const allSubTargetsHaveMaintenanceData = subTargets.every(subTarget => {
        const dataTaken = targetDataCountByTargetId.get(subTarget.ID ?? 0) ?? 0;
        const desiredTrials = subTarget.DesiredTrials ?? 1;
        return dataTaken >= desiredTrials;
      });

      return target.TargetStatus === PatientTargetStatus.Maintenance && allSubTargetsHaveMaintenanceData;
    }

    const desiredTrials = target.DesiredTrials ?? 1;
    const dataTaken = targetDataCountByTargetId.get(target.ID ?? 0) ?? 0;

    if (target.MaintenanceDataTaken) {
      return true;
    }

    if (target.TargetStatus === PatientTargetStatus.Maintenance) {
      return dataTaken >= desiredTrials;
    }

    return false;
  }

  getImageUrl(attachment: GeneralAttachmentModel) : string {
    var url = 'data:'+ attachment.FileType +';base64,'+ attachment.ImageThumbnail;
    return url;
  }

  openAttachmentView(attachment: GeneralAttachmentModel) : void {
    this.doShowAttachmentView = true;
    this.selectedAttachment = attachment;
  }

  closeAttachmentView() {
    this.doShowAttachmentView = false;
    this.selectedAttachment = null;
    if(this.isOfflineMode){
      return;
    }
    this.loadAttachments();
  }
  loadAttachments(){
    if(this.isOfflineMode || this.lightLoad.isEnabled()){
      return;
    }
    const requestedPatientID = Number(this.patientID);
    this.supervisorApiService.GetPatientInstructionAttachments({
      patientID: requestedPatientID
    })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
      next: (results) => {
        if (Number(this.patientID) !== requestedPatientID) {
          return;
        }
        this.instructionFiles = results;
      },
      error: (error) => {
        console.error('Error loading patient instruction attachments', error);
        this.alertService.error('Failed to load patient instruction attachments');
        this.loading = false;
      }
    });
  }
  getData(): void {
    // Prevent concurrent data loading operations to avoid memory spikes
    if (this.isLoadingData) {
      console.log('Data loading already in progress, skipping duplicate request');
      this.addStaffTrace('staff-home-getdata-skipped-already-loading', {
        patientID: this.patientID ?? null,
        sessionID: this.sessionID ?? null,
      });
      return;
    }
    this.addStaffTrace('staff-home-getdata-started', {
      patientID: this.patientID ?? null,
      sessionID: this.sessionID ?? null,
      isOfflineMode: this.isOfflineMode,
      isPreview: this.isPreview,
    });
    // Get offline data or download it if not available
    this.getOfflineData();
  }

  private getSessionIdToRefresh(): number | undefined {
    const sessionID = Number(this.sessionID);
    return !this.isPreview && Number.isFinite(sessionID) && sessionID > 0
      ? sessionID
      : undefined;
  }

  getOfflineData(): void {
    // Prevent concurrent data loading operations
    if (this.isLoadingData) {
      console.log('Offline data loading already in progress, skipping duplicate request');
      return;
    }
    
    this.isLoadingData = true;
    this.loading = true;
    this.startLoadingWatchdog();

    // Get the offline patient data
    if (!this.patientID) {
      this.sendLogsService.addError('Staff home missing patient ID while loading data');
      this.alertService.error('Patient ID is missing');
      this.loading = false;
      this.isLoadingData = false;
      this.clearLoadingWatchdog();
      return;
    }
    const numericPatientId = Number(this.patientID);
    const loadGeneration = ++this.dataLoadGeneration;

    if (!this.isOfflineMode) {
      const cachedOfflineData =
        this.offlineDataService.getOfflinePatientData(numericPatientId);
      const hasUnsyncedLocalData =
        this.offlineDataService.hasUnsyncedPatientData(numericPatientId);
      const sessionIdToRefresh = this.getSessionIdToRefresh();

      // Cache-first for preview and unsynced data to avoid blocking initial render
      // on the slowest server-side session payloads.
      if (
        cachedOfflineData &&
        (this.isPreview || hasUnsyncedLocalData)
      ) {
        this.addStaffTrace('staff-home-using-cached-offline-data', {
          patientID: numericPatientId,
          hasUnsyncedLocalData,
          isPreview: this.isPreview,
        });
        this.initializeDisplayItems(cachedOfflineData);
        this.isLoadingData = false;
        this.loading = false;

        // Keep cache fresh in background without blocking UI.
        this.offlineDataService
          .savePatientForOffline(numericPatientId, false, sessionIdToRefresh)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (result) => {
              if (
                !result ||
                !this.isCurrentDataLoad(numericPatientId, loadGeneration)
              ) {
                return;
              }
              const refreshedOfflineData =
                this.offlineDataService.getOfflinePatientData(numericPatientId);
              if (refreshedOfflineData) {
                this.initializeDisplayItems(refreshedOfflineData);
              }
            },
            error: (error) => {
              if (!this.isCurrentDataLoad(numericPatientId, loadGeneration)) {
                return;
              }
              console.error(
                'Error refreshing cached patient data in background:',
                error
              );
              this.sendLogsService.addError(
                'Staff home background refresh failed',
                error?.stack || JSON.stringify(error)
              );
            },
          });
        return;
      }

      // Get the offline data from the server
      this.offlineDataService
        .savePatientForOffline(numericPatientId, false, sessionIdToRefresh)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (result) => {
            if (!this.isCurrentDataLoad(numericPatientId, loadGeneration)) {
              return;
            }
            const offlineData = this.offlineDataService.getOfflinePatientData(
              numericPatientId
            );
            if (result && offlineData) {
              this.initializeDisplayItems(offlineData);
            } else if (offlineData) {
              // Use last known cache when refresh fails but local data exists.
              this.initializeDisplayItems(offlineData);
            } else {
              this.sendLogsService.addError(
                'Staff home failed to get patient data and no cache fallback',
                JSON.stringify({
                  patientID: numericPatientId,
                  sessionID: sessionIdToRefresh ?? null,
                })
              );
              this.alertService.error('Failed to get patient data');
              this.loading = false;
            }
            this.isLoadingData = false;
            this.clearLoadingWatchdog();
          },
          error: (error) => {
            if (!this.isCurrentDataLoad(numericPatientId, loadGeneration)) {
              return;
            }
            console.error('Error loading patient data:', error);
            this.sendLogsService.addError(
              'Staff home savePatientForOffline failed',
              error?.stack || JSON.stringify(error)
            );
            this.alertService.error('Failed to load patient data');
            this.loading = false;
            this.isLoadingData = false;
            this.clearLoadingWatchdog();
          }
        });
    } else {
      const offlineData = this.offlineDataService.getOfflinePatientData(Number(this.patientID));

      if (offlineData) {
        this.initializeDisplayItems(offlineData);
      } else {
        this.sendLogsService.addError(
          'Staff home patient data unavailable in offline mode',
          JSON.stringify({ patientID: this.patientID ?? null })
        );
        this.alertService.error('Patient data not available offline');
        this.loading = false;
      }

      this.isLoadingData = false;
      this.loading = false;
      this.clearLoadingWatchdog();
    }
  }

  private isCurrentDataLoad(
    patientID: number,
    loadGeneration: number
  ): boolean {
    return (
      this.dataLoadGeneration === loadGeneration &&
      Number(this.patientID) === patientID
    );
  }

  countFinishedTrialsTargets(program: PatientProgramModel): number {
    if (program.ID == null) {
      return 0;
    }

    return this.finishedTrialsByProgram[program.ID] ?? 0;
  }


  startSession() {
    this.isStartingSession = true;
    if (this.isPreview) {
      this.patientSessionService.initializePatientSession(this.patientID, -1);
      this.patientSessionService.startSession();
    } else {
      this.patientSessionService.startSession();
    }
  }

  isStarted(): boolean {
    return !!(
      this.patientSession && this.patientSession?.StartedDate && !this.patientSession?.FinishedDate
    );
  }

  isSessionFinished(): boolean {
    return !!(
      this.patientSession && this.patientSession?.FinishedDate
    );
  }

  isSessionDeleted(): boolean {
    return !!(
      this.patientSession && this.patientSession?.DeletedDate
    );
  }

  supportProgressNote(): boolean {
    if (this.offlineDataService.hasOfflinePatientData(this.patientID ?? 0)) {
      // Get treatment goals from offline data
      const offlineData = this.offlineDataService.getOfflinePatientData(this.patientID ?? 0);
      if (offlineData && offlineData.skillAcquisitionGoals) {
        
        // Try to get progress notes from offline storage
        const offlineProgressNote = this.offlineDataService.getOfflineSessionProgressNotes(this.patientID ?? 0, this.sessionID ?? 0);
        if (offlineProgressNote) {
          return offlineProgressNote.SupportSessionNoteMapping ?? false;
        }
      }
    }
    return true;
  }

  private updateTimer(): void {
    if (this.isDestroyed) {
      return;
    }

    if (this.isStarted()) {
      this.isTimerRunning = true;
      const currentTime = new Date(new Date().toServerString()).getTime();
      const startTime = new Date(this.patientSession?.StartedDate!).getTime();
      this.timerValue = Math.floor((currentTime - startTime) / 1000);

      //check if the reminder should be shown based on its interval and the session time
      this.checkReminders();
      if (this.timerTimeoutId) {
        clearTimeout(this.timerTimeoutId);
      }
      this.timerTimeoutId = setTimeout(() => this.updateTimer(), 1000);
    }
  }

  private checkReminders(): void {
    this.showingReminders = this.reminders.filter(
      (r) => 
        ((this.checkReminder(r) == true && !r.lastTimeClosed) ||
        (r.DoRepeat == true && this.checkReminder(r) == true && r.Interval != null && r.Interval > 0 && this.timerValue - (r.lastTimeClosed ?? 0) >= (r.Interval * 60)))
    );
  }

  checkReminder (reminder: PatientReminderWithLastTimeModel): boolean {
    var newDate = new Date();
    var month = newDate.getMonth();
    var dayOfWeek = newDate.getDay();
    var dayOfMonth = newDate.getDate();
    var hours = newDate.getHours();
    var minutes = newDate.getMinutes();

    var date = new Date(reminder.Time ?? "");

    var reminderDate = new Date(newDate.getFullYear(), month, dayOfMonth, date.getHours(), date.getMinutes());
    var reminderHours = reminderDate.getHours();
    var reminderminutes = reminderDate.getMinutes();

    if(reminder.Type == "Daily"){
      var mins = minutes;
      if(reminderHours < hours){
        mins = ((hours - reminderHours) * 60) + minutes;
      }
      if (reminderHours <= hours && reminderminutes <= mins){
        return true;
      } 
    }
    else if(reminder.Type == "Weekly"){
      var dayOfWeekIndexes = this.getDayOfWeekIndexes(reminder.Days);
      var mins = minutes;
      if(reminderHours < hours){
        mins = ((hours - reminderHours) * 60) + minutes;
      }
      if (dayOfWeekIndexes.includes(dayOfWeek) && reminderHours <= hours && reminderminutes <= mins){
        return true;
      }
    }
    else if(reminder.Type == "Monthly"){
      var dayCheck = this.isSelectedDayOfMonth(reminder?.Days, reminder.WeekOfMonth, dayOfMonth );
      var dayOfWeekIndexes = this.getDayOfWeekIndexes(reminder.Days);
      var mins = minutes;
      if(reminderHours < hours){
        mins = ((hours - reminderHours) * 60) + minutes;
      }
      if (dayOfWeekIndexes.includes(dayOfWeek) && dayCheck == true && reminderHours <= hours && reminderminutes <= mins){
        return true;
      } 
    }
    return false;
  }

  getDayOfWeekIndexes(days: string | null | undefined) : number[] {
    var indexes: number[] = [];

    if(days?.includes("Monday")){
      indexes.push(1);
    }
    if(days?.includes("Tuesday")){
      indexes.push(2);
    }
    if(days?.includes("Wednesday")){
      indexes.push(3);
    }
    if(days?.includes("Thursday")){
      indexes.push(4);
    }
    if(days?.includes("Friday")){
      indexes.push(5);
    }
    if(days?.includes("Saturday")){
      indexes.push(6);
    }
    if(days?.includes("Sunday")){
      indexes.push(0);
    }

    return indexes;
  }

  isSelectedDayOfMonth(days: string | null | undefined, week: number | null | undefined, dayNumber: number) : boolean {
    var check = false;
    var arr = days?.split(",");
    for (var day of arr ?? [] ){
      if(day?.includes("Monday")){
        var result = this.findWeekDayOfMonth(1, week);
        check = result == dayNumber;
      }
      if(day?.includes("Tuesday")){
        var result = this.findWeekDayOfMonth(2, week);
        check = result == dayNumber;
      }
      if(day?.includes("Wednesday")){
        var result = this.findWeekDayOfMonth(3, week);
        check = result == dayNumber;
      }
      if(day?.includes("Thursday")){
        var result = this.findWeekDayOfMonth(4, week);
        check = result == dayNumber;
      }
      if(day?.includes("Friday")){
        var result = this.findWeekDayOfMonth(5, week);
        check = result == dayNumber;
      }
      if(day?.includes("Saturday")){
        var result = this.findWeekDayOfMonth(6, week);
        check = result == dayNumber;
      }
      if(day?.includes("Sunday")){
        var result = this.findWeekDayOfMonth(0, week);
        check = result == dayNumber;
      }
    }
    return check;
  }

  findWeekDayOfMonth(dayOfWeek: number, week: number | null | undefined) : number {
    var today = new Date();
    const firstOfMonthDate = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
    let firstOfMonth = firstOfMonthDate.getDay(); // 0 (Sunday) to 6 (Saturday)
    let dayOfMonth = 1;

    // Find the first selected day
    while (firstOfMonth !== dayOfWeek) {
      dayOfMonth++;
      firstOfMonth = (firstOfMonth + 1) % 7;
    }
  
    // Add days to get the selected day
    if(week != null && week > 1)
      dayOfMonth += 7 * ((week ?? 1) - 1);
  
    return dayOfMonth;
  }

  closeReminder(reminder: PatientReminderWithLastTimeModel) {
    //increase the reminder counter
    if (reminder.Interval) {
      reminder.lastTimeClosed =
        Math.floor(this.timerValue / (reminder.Interval * 60)) * (reminder.Interval * 60);
    } else {
      reminder.lastTimeClosed = this.timerValue;
    }
    this.checkReminders();
    localStorage.setItem(
      this.patientStorageKey('reminders'),
      JSON.stringify(this.reminders)
    );
  }

  wasSessionAlreadyProcessed(): boolean {
    return this.patientSession?.FinishedHandledDate != null;
  }

  endSession() {
    if (this.wasSessionAlreadyProcessed()) {
      this.endAlreadyProcessedSession();
    } else {
      if (this.isOfflineMode && this.patientID) {
        this.showEndSession = true;
      } else {
        if (this.isPreview) {
          this.alertService.error('This is a preview of how the session will look like. On a real session you will be able to end the session by clicking this button.');
        } else {
          this.showEndSession = true;
        }
      }
    }
  }

  endAlreadyProcessedSession() {
    this.justFinishedSession = true;
    this.patientSessionService.endSession(this.patientSession!)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
      if (this.groupMode) {
        this.groupSessionFinished.emit();
        return;
      }
      if (this.offlineDataService.isInOfflineMode()) {
        this.alertService.success('Session ended successfully. Your data is saved offline, remember to access Spark when you\'re online to get it uploaded.');
        this.router.navigate(['/offline/patients']);
      } else {
        if (this.patientSession?.ServiceID) {
          this.alertService.confirm('Session ended successfully', 'Would you like to go back to Opto to create the documentation?')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(result => {
            if (result) {
              window.open(this.authService.getOptoURL() ? (this.authService.getOptoURL() + '/TreatmentReports/Documentation/CreateSparkDoc/' + this.patientSession?.ServiceID + '/' + this.patientID) : '/');
              setTimeout(() => {
                this.navigateWithAcademyMode(['/staff/' + this.patientID + '/sessions']);
              }, 1000);
            } else {
              this.alertService.success('Session ended successfully');
              setTimeout(() => {
                this.navigateWithAcademyMode(['/staff/' + this.patientID + '/sessions']);
              }, 1000);
            }
          }, error => {
            this.alertService.success('Session ended successfully');
            setTimeout(() => {
              this.navigateWithAcademyMode(['/staff/' + this.patientID + '/sessions']);
            }, 1000);
          });
        } else {
          this.alertService.success('Session ended successfully');
          setTimeout(() => {
            this.navigateWithAcademyMode(['/staff/' + this.patientID + '/sessions']);
          }, 1000);
        }
      }
    });
  }

  onCloseEndSession() {
    this.showEndSession = false;
  }

  onEndSessionFinished() {
    this.justFinishedSession = true;
    this.showEndSession = false;
    if (this.groupMode) {
      this.groupSessionFinished.emit();
    }
  }

  timerString() {
    const minutes = Math.floor(this.timerValue / 60);
    const seconds = this.timerValue % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }

  switchToSupervisor() {
    this.navigateWithAcademyMode(['/supervisor/' + this.patientID]);
  }

  switchToGraphs() {
    this.navigateWithAcademyMode(['/graphs/' + this.patientID]);
  }

  private navigateWithAcademyMode(commands: any[]): void {
    this.router.navigate(commands, {
      queryParams: this.academyModeService.getAcademyModeQueryParams(),
    });
  }

  private patientStorageKey(key: string): string {
    return this.patientID ? `${key}:${this.patientID}` : key;
  }

  getShowingItemsGroupedByTitle() {
    const groupedItems = this.showingItems.reduce(
      (
        acc: {
          Title: string;
          items: {
            Title: string;
            Name: string;
            Targets: PatientTargetModel[];
          }[];
        }[],
        item
      ) => {
        const existing = acc.find((group) => group.Title === item.Title);
        if (!existing) {
          acc.push({ Title: item.Title, items: [item] });
        } else {
          existing.items.push(item);
        }
        return acc;
      },
      []
    );

    return groupedItems;
  }

  selectProgram(program: PatientProgramModel) {

    this.selectedProgramIndex = this.filteredPrograms.findIndex(
      (p) => p.ID === program.ID
    );
    this.selectedPlaylistIndex = -1;
    this.selectedTargetIndex = -1;
    this.updateShowingItems();
  }

  private getDisplayTargets(targets: PatientTargetModel[] | null | undefined): PatientTargetModel[] {
    return (targets ?? []).filter(target => !target.IsTargetSubtarget);
  }

  updateShowingItems() {
    if (this.selectedProgramIndex >= 0) {
      const program = this.filteredPrograms[this.selectedProgramIndex];
      this.showingItems = [
        {
          Title: program.SkillAreaName ?? '',
          Name: program.ProgramName ?? '',
          Targets: this.getDisplayTargets(program.Targets),
          ProgramID: program.ID,
          ShowMasteredTargets: program.ID ? this.showMasteredTargetsOnProgram[program.ID] : false,
          ShowMaintenanceTargets: program.ID ? this.showMaintenanceTargetsOnProgram[program.ID] : false,
          ProgramNotes: program.ProgramNotes ?? '',
          ProgramNotesLastModifiedByUserFullName: program.NotesLastModifiedByUserFullName ?? '',
          ProgramNotesLastModifiedDate: program.NotesLastModifiedDate ?? '',
        },
      ];
      this.groupedShowingItems = this.getShowingItemsGroupedByTitle();
    } else if (this.selectedPlaylistIndex >= 0) {
      const playlist = this.filteredPlaylists[this.selectedPlaylistIndex];
      const programs: PatientProgramModel[] = [];
      playlist.Items?.forEach((item) => {
        const program = this.programs.find((p) => p.ID === item.PatientProgramID);
        if (program) {
          programs.push(program);
        } else {
          const target = this.targets.find((t) => t.ID === item.PatientTargetID);
          if (target && !target.IsTargetSubtarget) {
            programs.push({
              SkillAreaName: 'Targets',
              ProgramName: target.TargetName,
              Targets: [target],
            });
          }
        }
      });
      this.showingItems = programs.map((p) => ({
        Title: p.SkillAreaName ?? '',
        Name: p.ProgramName ?? '',
        Targets: this.getDisplayTargets(p.Targets),
        ProgramID: p.ID,
        ShowMaintenanceTargets: p.ID ? this.showMaintenanceTargetsOnProgram[p.ID] : false,
        ShowMasteredTargets: p.ID ? this.showMasteredTargetsOnProgram[p.ID] : false,
        ProgramNotes: p.ProgramNotes ?? '',
        ProgramNotesLastModifiedByUserFullName: p.NotesLastModifiedByUserFullName ?? '',
        ProgramNotesLastModifiedDate: p.NotesLastModifiedDate ?? '',
      }));
      this.groupedShowingItems = this.getShowingItemsGroupedByTitle();
    } else if (this.selectedTargetIndex >= 0) {
      const target = this.filteredTargets[this.selectedTargetIndex];
      this.showingItems = [
        { Title: 'Targets', Name: target.TargetName ?? '', Targets: [target], TargetID: target.ID ?? undefined, TargetNotes: target.TargetNotes ?? '', TargetNotesLastModifiedByUserFullName: target.NotesLastModifiedByUserFullName ?? '', TargetNotesLastModifiedDate: target.NotesLastModifiedDate ?? '' },
      ];
      this.groupedShowingItems = this.getShowingItemsGroupedByTitle();
    }
  }

  selectPlaylist(playlist: PatientPlaylistModel) {
    this.selectedPlaylistIndex = this.filteredPlaylists.findIndex(
      (p) => p.ID === playlist.ID
    );
    this.selectedProgramIndex = -1;
    this.selectedTargetIndex = -1;
    this.updateShowingItems();
  }

  selectTarget(target: PatientTargetModel) {

    this.selectedTargetIndex = this.filteredTargets.findIndex(
      (t) => t.ID === target.ID
    );
    this.selectedProgramIndex = -1;
    this.selectedPlaylistIndex = -1;
    this.updateShowingItems();
  }

  nextOnList() {
    if (this.selectedTargetIndex >= 0) {
      this.nextTarget();
    } else if (this.selectedPlaylistIndex >= 0) {
      this.nextPlaylist();
    } else {
      if (this.selectedProgramIndex < 0) {
        this.selectedProgramIndex = -1;
      }
      this.nextProgram();
    }
  }

  showFilter() {
    this.showFilterDialog = !this.showFilterDialog;
    if (this.showFilterDialog) {
      //focus on the search input
      setTimeout(() => {
        const searchInput = document.querySelector(
          '.programs-list-search'
        ) as HTMLInputElement;
        if (searchInput) {
          searchInput.focus();
        }
      }, 100);
    }
  }
  clearSearchInput() {
    this.filterText = '';
    this.filterPrograms();
  }
  filterPrograms() {
    this.selectedProgramIndex = -1;
    this.selectedPlaylistIndex = -1;
    this.selectedTargetIndex = -1;
    this.filteredPrograms = this.programs.filter((p) =>
      p.ProgramName?.toLowerCase().includes(this.filterText.toLowerCase()) ||
      p.Targets?.some(target =>
        target.TargetName?.toLowerCase().includes(this.filterText.toLowerCase())
      )
    );
    this.filteredPlaylists = this.playlists.filter((p) =>
      p.PlaylistName?.toLowerCase().includes(this.filterText.toLowerCase()) ||
      p.Items?.some(item =>
        (item.PatientProgramID &&
          (this.programs.some(program => program.ID === item.PatientProgramID && program.ProgramName?.toLowerCase().includes(this.filterText.toLowerCase())))
          || (this.programs.some(program => program.ID === item.PatientProgramID && program.Targets?.some(target => target.TargetName?.toLowerCase().includes(this.filterText.toLowerCase()))))
        ) ||
        (item.PatientTargetID && this.targets.some(target => target.ID === item.PatientTargetID && target.TargetName?.toLowerCase().includes(this.filterText.toLowerCase())))
      )
    );
    this.filteredTargets = this.targets.filter((t) =>
      t.TargetName?.toLowerCase().includes(this.filterText.toLowerCase()) 
      && t.TargetStatus != PatientTargetStatus.Mastered
      && t.TargetStatus != PatientTargetStatus.Fluent
      && !this.programs.some(program =>
        program.Targets?.some(programTarget => programTarget.ID === t.ID)
      )
    );
  }

  nextProgram() {
    if (this.selectedProgramIndex + 1 >= this.filteredPrograms.length) {
      this.selectedProgramIndex = -1;
      this.selectedTargetIndex = -1;
      this.selectedPlaylistIndex = -1;
      this.nextPlaylist();
    } else {
      this.selectedProgramIndex++;
      this.selectProgram(this.filteredPrograms[this.selectedProgramIndex]);
    }
  }

  nextPlaylist() {
    if (this.selectedPlaylistIndex + 1 >= this.filteredPlaylists.length) {
      this.selectedPlaylistIndex = -1;
      this.selectedProgramIndex = -1;
      this.selectedTargetIndex = -1;
      this.nextTarget();
    } else {
      this.selectedPlaylistIndex++;
      this.selectPlaylist(this.filteredPlaylists[this.selectedPlaylistIndex]);
    }
  }

  nextTarget() {
    if (this.selectedTargetIndex + 1 >= this.filteredTargets.length) {
      //Nothing this is the end
    } else {
      this.selectedTargetIndex++;
      this.selectTarget(this.filteredTargets[this.selectedTargetIndex]);
    }
  }

  isFrequencyBehavior(behavior: PatientBehaviorModel): boolean {
    return behavior.BehaviorType === PatientBehaviorType.Frequency;
  }

  isDurationBehavior(behavior: PatientBehaviorModel): boolean {
    return behavior.BehaviorType === PatientBehaviorType.Duration;
  }

  isIntervalBehavior(behavior: PatientBehaviorModel): boolean {
    return behavior.BehaviorType === PatientBehaviorType.Interval;
  }

  isRateTimerBehavior(behavior: PatientBehaviorModel): boolean {
    return behavior.BehaviorType === PatientBehaviorType.RateTimer;
  }

  isIntensityBehavior(behavior: PatientBehaviorModel): boolean {
    return behavior.BehaviorType === PatientBehaviorType.Intensity;
  }

  showProgressNote() {
    if (!this.showingProgressNote) {
      this.showingProgressNote = true;
      //Animate progress-note div to be bigger
      const progressNote = document.querySelector(
        '.progress-note'
      ) as HTMLElement;
      if (progressNote) {
        if (window.innerWidth > 700) {
          progressNote.style.maxWidth = '700px';
          progressNote.style.width = '700px';
        } else {
          progressNote.style.maxWidth = window.innerWidth - 100 + 'px';
          progressNote.style.width = window.innerWidth - 100 + 'px';
        }
      }
      this.progressNoteComponent.progressNoteStep = 1;
      if (!this.isPreview) {
        this.progressNoteComponent.getData();
      }
    }
  }

  hideProgressNote() {
    if (this.showingProgressNote) {
      this.showingProgressNote = false;
      //Animate progress-note div to be smaller
      const progressNote = document.querySelector(
        '.progress-note'
      ) as HTMLElement;
      if (progressNote) {
        progressNote.style.maxWidth = '25px';
        progressNote.style.width = '25px';
      }
    }
  }

  showProgramNotes(
    programNotesDiv: HTMLDivElement,
    programNotesTextarea: HTMLTextAreaElement
  ) {
    programNotesDiv.style.height = '200px';
    programNotesTextarea.focus();
    programNotesTextarea.classList.add('focused');
    this.isProgramNotesShowing = true;
  }

  hideProgramNotes(
    programNotesDiv: HTMLDivElement,
    programNotesTextarea: HTMLTextAreaElement
  ) {
    programNotesDiv.style.height = '40px';
    programNotesTextarea.classList.remove('focused');
    this.isProgramNotesShowing = false;
  }

  startEditingProgramNotes() {
    this.isEditingProgramNotes = true;
  }

  cancelEditingProgramNotes() {
    this.isEditingProgramNotes = false;
  }

  showTargetNotes(
    targetNotesDiv: HTMLDivElement,
    targetNotesTextarea: HTMLTextAreaElement
  ) {
    targetNotesDiv.style.height = '200px';
    targetNotesTextarea.focus();
    targetNotesTextarea.classList.add('focused');
    this.isTargetNotesShowing = true;
  }

  hideTargetNotes(
    targetNotesDiv: HTMLDivElement,
    targetNotesTextarea: HTMLTextAreaElement
  ) {
    targetNotesDiv.style.height = '40px';
    targetNotesTextarea.classList.remove('focused');
    this.isTargetNotesShowing = false;
  }

  saveProgramNotes(programID: number, programNotes: string) {
    this.staffApiService
      .ChangeProgramNotes({ programId: programID, newNotes: programNotes, shouldMarkAsNew: true })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        console.log('Program notes updated');
        this.isEditingProgramNotes = false;
      });
  }

  saveTargetNotes(targetID: number, targetNotes: string) {
    this.staffApiService
      .ChangeTargetNotes({ targetId: targetID, newNotes: targetNotes, shouldMarkAsNew: true })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        console.log('Target notes updated');
        this.isEditingTargetNotes = false;
      });
  }

  onMenuTargetNoteChanged(
    target: {
      TargetNotes?: string;
      TargetNotesLastModifiedByUserFullName?: string;
      TargetNotesLastModifiedDate?: string;
    },
    message: TargetNoteMessageModel
  ) {
    target.TargetNotes = message.Message ?? target.TargetNotes;
    target.TargetNotesLastModifiedByUserFullName =
      message.CreatedByUserFullName ??
      target.TargetNotesLastModifiedByUserFullName;
    target.TargetNotesLastModifiedDate =
      message.CreatedDate ?? target.TargetNotesLastModifiedDate;
  }

  lastModifiedByTextForProgram(program: any): string {
    if (!program.ProgramNotesLastModifiedByUserFullName || !program.ProgramNotesLastModifiedDate) {
      return '';
    }
    return 'Last modified by: ' + program.ProgramNotesLastModifiedByUserFullName + ' at ';
  }

  lastModifiedByTextForTarget(target: any): string {
    if (!target.TargetNotesLastModifiedByUserFullName || !target.TargetNotesLastModifiedDate) {
      return '';
    }
    return 'Last modified by: ' + target.TargetNotesLastModifiedByUserFullName + ' at ';
  }

  cancelEditingTargetNotes() {
    this.isEditingTargetNotes = false;
  }

  startEditingTargetNotes() {
    this.isEditingTargetNotes = true;
  }


  loadExampleSessionForTour() {
    // TODO: this method should load: all the different target types, one favorite target, one special favorite target, all different behavior types;
    // TODO: it should override the already loaded data for the session;
  }

  openProgramDetails(item: any) {
    if (item.ProgramID) {
      const program = this.programs.find((p) => p.ID === item.ProgramID && p.Details);
      if (program) {
        this.programToShowDetails = program;
        this.detailsOpened = true;
      }

    }
  }

  onCloseDetails() {
    this.programToShowDetails = null;
    this.detailsOpened = false;
  }

  openPlaylistDetails() {
    if (this.selectedPlaylistIndex >= 0) {
      this.playlistToShowDetails = this.filteredPlaylists[this.selectedPlaylistIndex];
      if (this.playlistToShowDetails?.Details && this.playlistToShowDetails.Details.length > 0) {
        this.playlistDetailsOpened = true;
      }
    }
  }

  closePlaylistDetails() {
    this.playlistToShowDetails = null;
    this.playlistDetailsOpened = false;
  }

  toggleShowMasteredTargets(programID: number) {
    this.showMasteredTargetsOnProgram[programID] = !this.showMasteredTargetsOnProgram[programID];
    this.updateShowingItems();
    localStorage.setItem(this.patientStorageKey('showMasteredTargetsOnProgram'), JSON.stringify(this.showMasteredTargetsOnProgram));
  }

  toggleShowMaintenanceTargets(programID: number) {
    this.showMaintenanceTargetsOnProgram[programID] = !this.showMaintenanceTargetsOnProgram[programID];
    this.updateShowingItems();
    localStorage.setItem(this.patientStorageKey('showMaintenanceTargetsOnProgram'), JSON.stringify(this.showMaintenanceTargetsOnProgram));
  }
  
  isMaintenaceTaken(target: PatientTargetModel, programID: number | undefined){
    if (target == null || target.ID == null) {
      return false;
    }

    if (programID != null && this.showMaintenanceTargetsOnProgram[programID]) {
      return false;
    }

    return this.maintenanceTakenByTargetId[target.ID] ?? false;
  }

  openPatientInstructions() {
    this.patientInstructionsOpened = true;
  }

  closePatientInstructions() {
    this.patientInstructionsOpened = false;
  }

  openBIP(setting: string) {
    if (this.patient && this.patient.LastBIPDocumentationID != null) {

      if (setting == "Home") {
        window.open(this.authService.getOptoURL() + '/TreatmentReports/Documentation/DocumentView/' + this.patient.LastBIPDocumentationID + '?viewNumber=1', setting);
      }
      if (setting == "Community") {
        window.open(this.authService.getOptoURL() + '/TreatmentReports/Documentation/DocumentView/' + this.patient.LastBIPDocumentationID + '?viewNumber=2', setting);
      }
      if (setting == "Clinic") {
        window.open(this.authService.getOptoURL() + '/TreatmentReports/Documentation/DocumentView/' + this.patient.LastBIPDocumentationID + '?viewNumber=3', setting);
      } else {
        window.open(this.authService.getOptoURL() + '/TreatmentReports/Documentation/DocumentView/' + this.patient.LastBIPDocumentationID, setting);
      }
    } else {
      this.alertService.error("Patient has no BIP.");
    }
  }
  reloadData(){
    this.getData();
  }

  canUseTwoToOneSessionSync(): boolean {
    return (
      !this.isPreview &&
      !this.isOfflineMode &&
      this.isStarted() &&
      !!this.patientID &&
      !!this.sessionID
    );
  }

  isTwoToOneSessionSyncRunning(): boolean {
    return this.sessionCollaborationSyncService.isRunning();
  }

  toggleTwoToOneSessionSync(): void {
    if (this.isTwoToOneSessionSyncRunning()) {
      this.sessionCollaborationSyncService.stop();
      return;
    }

    if (!this.canUseTwoToOneSessionSync() || !this.patientID || !this.sessionID) {
      return;
    }

    this.sessionCollaborationSyncService.start(this.patientID, this.sessionID);
  }

  openBipView(view: 'QuickReference' | 'Behaviors' | 'CrisisCycle' | 'EmergencyProcedures' | 'AdditionalInfo') {
    this.bipView = view;
    this.showBipDialog = true;
  }
  closeBipView() {
    this.showBipDialog = false;
    this.bipView = null;
    this.bipScrollFragment = null;
  }

  onQuickRefStrategySelected(e: { fragment: string }) {
    this.bipScrollFragment = e.fragment;
    this.bipView = 'Behaviors';
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.isTimerRunning = false;
    this.sessionCollaborationSyncService.stop();
    if (this.timerTimeoutId) {
      clearTimeout(this.timerTimeoutId);
      this.timerTimeoutId = null;
    }
    this.clearLoadingWatchdog();

    // Clear large data structures to free memory
    this.clearComponentData();
  }

  private clearComponentData(): void {
    // Clear large arrays and objects to help with garbage collection
    this.programs = [];
    this.playlists = [];
    this.targets = [];
    this.behaviors = [];
    this.filteredPrograms = [];
    this.filteredPlaylists = [];
    this.filteredTargets = [];
    this.favoriteTargets = [];
    this.specialFavoriteTargets = [];
    this.showingItems = [];
    this.groupedShowingItems = [];
    this.reminders = [];
    this.showingReminders = [];
    this.subTargetsDictionary = {};
    this.targetsData = [];
    this.genericPromptCodes = [];
    this.promptSchedules = [];
    this.instructionFiles = [];
    this.finishedTrialsByProgram = {};
    this.maintenanceTakenByTargetId = {};
    
    // Clear other references
    this.patient = null;
    this.patientSession = null;
    this.programToShowDetails = null;
    this.selectedAttachment = null;
  }

  private addStaffTrace(message: string, context?: Record<string, unknown>): void {
    const ctx = context ? JSON.stringify(context) : undefined;
    this.sendLogsService.addDiagnostic(message, ctx);
  }

  private startLoadingWatchdog(): void {
    this.clearLoadingWatchdog();
    this.loadingWatchdogTimerId = setTimeout(() => {
      this.sendLogsService.addError(
        'Staff home loading watchdog fired (>45s)',
        JSON.stringify({
          patientID: this.patientID ?? null,
          sessionID: this.sessionID ?? null,
          isPreview: this.isPreview,
          isOfflineMode: this.isOfflineMode,
          isLoadingData: this.isLoadingData,
          loading: this.loading,
        })
      );
    }, 45000);
  }

  private clearLoadingWatchdog(): void {
    if (this.loadingWatchdogTimerId) {
      clearTimeout(this.loadingWatchdogTimerId);
      this.loadingWatchdogTimerId = null;
    }
  }
}
